import { ProductsService } from '@appStore/products/services/product.service';
import { AgreementService } from '@appStore/products/services/agreement.service';
import { ServiceAgreementService } from '@appStore/products/services/service-agreement.service';

export const services: any[] = [ ProductsService, AgreementService, ServiceAgreementService ];

export * from '@appStore/products/services/product.service';
export * from '@appStore/products/services/agreement.service';
export * from '@appStore/products/services/service-agreement.service';
